export const SURFACE_PROFILE_LABEL = 'Profile' as const;
export const CUSTOMER_PROFILE_LABEL = `Customer ${SURFACE_PROFILE_LABEL}` as const;
export const MSP_PROFILE_LABEL = `MSP ${SURFACE_PROFILE_LABEL}` as const;
export const ADMIN_PROFILE_LABEL = `Admin ${SURFACE_PROFILE_LABEL}` as const;
export const SUPPLIER_PROFILE_LABEL = `Supplier ${SURFACE_PROFILE_LABEL}` as const;
export const SWITCH_PROFILE_LABEL = `Switch ${SURFACE_PROFILE_LABEL}` as const;

export function buildSurfaceViewLabel(surface: string | null | undefined) {
  return surface ? `${surface} ${SURFACE_PROFILE_LABEL}` : SURFACE_PROFILE_LABEL;
}

export function buildSwitchSurfaceLabel() {
  return SWITCH_PROFILE_LABEL;
}
